var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconXTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.905 10.4695L21.3512 2H19.5869L13.1184 9.35244L7.95583 2H2L9.80863 13.1192L2 22H3.76429L10.591 14.2338L16.0442 22H22L13.905 10.4695ZM11.4877 13.2168L10.6954 12.1089L4.40053 3.30146H7.11084L12.1925 10.412L12.9815 11.5199L19.5861 20.7619H16.8758L11.4877 13.2168Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXTwitter);
export default __webpack_public_path__ + "static/media/icon-x-twitter.7b9997ba4796a785805d3c1beda0b3e2.svg";
export { ForwardRef as ReactComponent };